module.exports = __webpack_public_path__ + "img/publish-success.8dd2efb1.png";